module.exports = __webpack_public_path__ + "img/icon101.bed389cc.png";